/*********************
* Rule Factory *
*
* instantiates and returns rules of specified type
*********************/
import { ruleTypes } from '../../constants';

// Word Metadata Rules
import WordDifficultyRule from './word_metadata_rules/WordDifficultyRule';
import WordReadingDifficultyRule from './word_metadata_rules/WordReadingDifficultyRule';
import WordAreaCheckRule from './word_metadata_rules/WordAreaCheckRule';
import LetterRule from './word_metadata_rules/LetterRule';
import SyllableRule from './word_metadata_rules/SyllableRule';
import PhonemeRule from './word_metadata_rules/PhonemeRule';
import SightWordRule from './word_metadata_rules/SightWordRule';
import GraphemeRule from './word_metadata_rules/GraphemeRule';
import LettersVsPhonemesRule from "./word_metadata_rules/LettersVsPhonemesRule";
import NgramCountRule from "./word_metadata_rules/NgramCountRule";

//Student Metadata Rules
import ESLRule from "./student_metadata/ESLRule";
import EarlyReaderRule from "./student_metadata/EarlyReaderRule";

// Error Type Rules
import RushingRule from './error_type_rules/RushingRule';
import SkipRule from './error_type_rules/SkipRule';
import CloseRule from './error_type_rules/CloseRule';
import StemRule from './error_type_rules/StemRule';

// Misc Rules
import DecodingRule from './DecodingRule';
import StudentAreaCheckRule from './StudentAreaCheckRule';
import InterventionOccurrenceRule from './InterventionOccurrenceRule';
import RecentOccurrenceRule from './RecentOccurrenceRule';
import RelativeRecentOccurrenceRule from './RelativeRecentOccurrenceRule';
import PhraseIndexRule from './PhraseIndexRule';
import EndOfPhraseRule from './EndOfPhraseRule';
import FrameTimeRule from './FrameTimeRule';

// Special "combo" rules, which take rules as their "logic"
import OrRule from './combo_rules/OrRule';
import AndRule from './combo_rules/AndRule';

// Accuracy Rules
import MostRecentAccuracyRule from "./MostRecentAccuracyRule";

export default function getRule(ruleType, logic, interventionType) {
  let rule = null;
  switch(ruleType) {
    case ruleTypes.DIFFICULTY:
      rule = new WordDifficultyRule(logic);
      break;
    case ruleTypes.READING_DIFFICULTY:
      rule = new WordReadingDifficultyRule(logic);
      break;
    case ruleTypes.WORD_AREA_CHECK:
      rule = new WordAreaCheckRule(logic);
      break;
    case ruleTypes.LETTER:
      rule = new LetterRule(logic);
      break;
    case ruleTypes.SYLLABLE:
      rule = new SyllableRule(logic);
      break;
    case ruleTypes.ESL:
      rule = new ESLRule(logic);
      break;
    case ruleTypes.DECODING:
      rule = new DecodingRule(logic);
      break;
    case ruleTypes.STUDENT_AREA:
      rule = new StudentAreaCheckRule(logic);
      break;
    case ruleTypes.PHONEME:
      rule = new PhonemeRule(logic);
      break;
    case ruleTypes.GRAPHEME:
      rule = new GraphemeRule(logic);
      break;
    case ruleTypes.RUSHING:
      rule = new RushingRule(logic);
      break;
    case ruleTypes.SKIP:
      rule = new SkipRule(logic);
      break;
    case ruleTypes.STEM:
      rule = new StemRule(logic);
      break;
    case ruleTypes.INTERVENTION_OCCURRENCE:
      rule = new InterventionOccurrenceRule(logic, interventionType);
      break;
    case ruleTypes.RECENT_OCCURRENCE:
      rule = new RecentOccurrenceRule(logic, interventionType);
      break;
    case ruleTypes.RELATIVE_RECENT_OCCURRENCE:
      rule = new RelativeRecentOccurrenceRule(logic, interventionType);
      break;
    case ruleTypes.SIGHT:
      rule = new SightWordRule(logic);
      break;
    case ruleTypes.CLOSE:
      rule = new CloseRule(logic);
      break;
    case ruleTypes.PHRASE:
      rule = new PhraseIndexRule(logic);
      break;
    case ruleTypes.END_OF_PHRASE:
      rule = new EndOfPhraseRule(logic);
      break;
    case ruleTypes.FRAME_TIME:
      rule = new FrameTimeRule(logic);
      break;
    case ruleTypes.OR:
      rule = new OrRule(logic, interventionType);
      break;
    case ruleTypes.AND:
      rule = new AndRule(logic, interventionType);
      break;
    case ruleTypes.MOST_RECENT_ACCURACY:
      rule = new MostRecentAccuracyRule(logic, interventionType);
      break;
    case ruleTypes.LETTERS_VS_PHONEMES:
      rule = new LettersVsPhonemesRule(logic, interventionType);
      break;
    case ruleTypes.NGRAM_COUNT:
      rule = new NgramCountRule(logic, interventionType);
      break;
    case ruleTypes.EARLY_READER:
      rule = new EarlyReaderRule(logic, interventionType);
      break;
    default:
      console.log('ERROR: invalid rule type as a param of ruleFactory: ', ruleType);
  }
  return rule;
}